import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'
import { EditJobDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import EditJobDialog from '@/routes/_app/-dialogs/edit-job'

export const Route = createFileRoute('/@modal/jobs/$jobId/edit')({
  params: idParams('jobId'),
  staticData: { slotScope: '/_app' },
  loader: ({ params, context }) => {
    // query: direct the job form keys its own read (it also edits the selected job); no route owns a dialog's key
    // prefetch: speculative warms that read on intent, before the click opens the form
    context.queryClient.query(trpc.jobs.getJob.queryOptions({ jobId: Number(params.jobId) })).catch(noop)
  },
  pendingComponent: EditJobDialogPending,
  component: EditJobSlot,
})

function EditJobSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditJobDialog jobId={Number(params.jobId)} {...slot} />
}
